<script lang="ts">
  import type { LayoutProps } from "./layoutTypes";

  const { ContentMain }: LayoutProps = $props();
</script>

<div class="wrapper-fullscreen" data-layout="fullscreen">
  {@render ContentMain?.()}
</div>

<style>
  .wrapper-fullscreen {
    width: 100%;
    height: 100%;
  }
</style>
